import { render, staticRenderFns } from "./resistanceTorque.vue?vue&type=template&id=1fc12628&"
import script from "./resistanceTorque.vue?vue&type=script&lang=js&"
export * from "./resistanceTorque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports